/**
 * GradientContainer Component
 * 
 * Reusable wrapper for content sections with gradient backgrounds.
 * Provides consistent styling for different page variants.
 * 
 * Props:
 * - variant: Gradient style variant ("default", "createlink", "fullAgenda")
 * - children: Content to wrap
 * - className: Additional CSS classes
 */

import React from 'react';

const GradientContainer = ({ 
  variant = "default", 
  children, 
  className = "" 
}) => {
  // Map variants to CSS classes
  const variantClasses = {
    default: "",
    createlink: "createlink-gradient",
    fullAgenda: "fullAgenda-gradient"
  };

  const variantClass = variantClasses[variant] || "";
  const containerClass = `gradient-container ${variantClass} ${className}`.trim();

  return (
    <div className={containerClass}>
      {children}
    </div>
  );
};

export default GradientContainer;